class Status {

    static url = "./statuses";

    static find(id) {
        return axios.get(Status.url + "/" + id)
    }


    static all(then) {

        return axios.get(Status.url)
            .then((dataz) => then(dataz.data))

    }


}

export default Status;
